__turbopack_context__.v({
  "container": "_4JiRba_container",
  "productActions": "_4JiRba_productActions",
  "productContent": "_4JiRba_productContent",
  "productDescription": "_4JiRba_productDescription",
  "productItem": "_4JiRba_productItem",
  "productTitle": "_4JiRba_productTitle",
  "root": "_4JiRba_root" + " " + __turbopack_context__.i(859805)["sectionMargin"],
});
